const highTrafficTemplate = require('../../views/high-traffic.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('hightraffic', {
            url: '/high-traffic',
            data: {
                analytics: `bws:web:high-traffic`
            },
            views: {
                '@': {
                    template: highTrafficTemplate
                },
                'hightraffic-content@hightraffic': {
                    template: '<wow-high-traffic class="error-page--high-traffic"></wow-high-traffic>'
                }
            }
        });
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/hightraffic.js
 **/